import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IFeedbackResolveRequest, IFeedbackResolveResponse } from '../models'

/**
 * Olumsuz geri bildirimi Geliştirildi/Kapatıldı olarak sonuçlandırır (Faz-37 §2). Duyuru yetkisini sunucu
 * ayrıca denetler (1403); zaten kapalı kayıt 1409, bulunamayan/olumsuz olmayan 1404, doğrulama 1400 döner.
 */
export class ResolveFeedbackApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo, feedbackId: number) {
    super({
      url: `admin/chatbot-analytics/feedback/${encodeURIComponent(String(feedbackId))}/resolve`,
      requesterInfo,
    })
  }

  public async resolve(request: IFeedbackResolveRequest): Promise<IFeedbackResolveResponse> {
    return await this.postAsync<IFeedbackResolveResponse>(request)
  }
}
